import React from 'react'
import { Svg } from './Svg'

export function CheckMark(props) {
    return (
        <Svg {...props} viewBox="0 0 256 256">
            <polyline fill="none" points="216 72 104 184 48 128" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
        </Svg>
    )
}